<template>
  <div class="page">
    <div class="site-logo">
      <img src="../assets/images/extra-logo.png" />
    </div>
  </div>
</template>

<script>
import cassApi from '@/api/cass'
import { userUtils } from '@/utils/auth'
export default {
  data () {
    return {
      formData: {
        extraAccount: '',
        cassAccount: '',
        cassWorkshopCode: '',
        loginType: 'wx'
      },
      paramData: {
        appCode: '',
        ts: '',
        sign: ''
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.formData.extraAccount = this.getQueryValue('extraAccount')
      this.formData.cassAccount = this.getQueryValue('cassAccount')
      this.formData.cassWorkshopCode = this.getQueryValue('cassWorkshopCode')
      this.paramData.appCode = this.getQueryValue('appCode')
      this.paramData.ts = this.getQueryValue('ts')
      this.paramData.sign = this.getQueryValue('sign')
      this.autoLogin()
    },
    // 获取url上参数
    getQueryValue (queryName) {
      const urlStr = decodeURI(window.location.search.substring(1))
      const urlArr = urlStr.split('&')
      for (let i = 0; i < urlArr.length; i++) {
        let param = urlArr[i].split('=')
        if (param[0] === queryName) {
          return param[1]
        }
      }
      return null
    },
    autoLogin () {
      const _self = this
      this.$toast.loading({
        duration: 1000,
        forbidClick: true,
        message: '自动登录中'
      })
      cassApi.autoLogin(this.formData, this.paramData.appCode, this.paramData.ts, this.paramData.sign).then(res => {
        if (res.data.resultCode === '0') {
          userUtils.setUserLocal(res.data.resutltData)
          this.$toast.loading({
            type: 'success',
            duration: 3000,
            message: '登录成功,即将跳转首页',
            onClose () {
              _self.$router.push('/')
            }
          })
        }
      }).catch(() => {
        this.$toast.loading({
          type: 'fail',
          duration: 3000,
          message: '登录失败,即将跳转首页',
          onClose () {
            _self.$router.push('/')
          }
        })
      })
    }
  }
}
</script>

<style lang='less' scoped>
.site-logo {
  width: 135px;
  // height: 64px;
  margin: 80px auto 20px auto;
}
img {
  width: 100%;
  height: 100%;
}
</style>
